export const FETCH_USER_TEAMS_START = 'FETCH_USER_TEAMS_START';
export const RECEIVE_ALL_USER_TEAMS = 'RECIVES_USER_TEAMS';
export const FETCH_USER_TEAMS_ERROR = 'FETCH_USER_TEAMS_ERROR';
export const USER_TEAMS_UPDATE = 'USER_TEAMS_UPDATE';
export const TEAMS_DELETE = 'TEAMS_DELETE';
export const USER_TEAM_CREATION = 'USER_TEAM_CREATION';
export const ADD_NEW_TEAM = 'ADD_NEW_TEAM';
export const UPDATE_TEAM = 'UPDATE_TEAM';
export const FETCH_TEAM_USERS_START = 'FETCH_TEAM_USERS_START';
export const RECEIVE_TEAM_USERS = 'RECEIVE_TEAM_USERS';
export const FETCH_TEAM_USERS_ERROR = 'FETCH_TEAM_USERS_ERROR';
export const TEAM_MEMBER_DELETE = 'TEAM_MEMBER_DELETE';
export const TEAM_MEMBER_ADD = 'TEAM_MEMBER_ADD';
export const UPDATE_TEAM_MEMBER_VISIBILITY = 'UPDATE_TEAM_MEMBER_VISIBILITY';
export const FETCH_ALL_TEAM_CODE_SUCCESS = 'FETCH_ALL_TEAM_CODE_SUCCESS';
export const FETCH_ALL_TEAM_CODE_FAILURE = 'FETCH_ALL_TEAM_CODE_FAILURE';
export const SET_ALL_TEAM_CODE = 'SET_ALL_TEAM_CODE';
